import styled from 'styled-components/macro'
import { darken } from 'polished'

export const Section = styled.section`
  margin: 0 auto;
  padding: 3.2rem 1.6rem;
  width: 100%;
  max-width: 66.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.4rem;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 5.4rem 3.2rem;
    max-width: 72.8rem;
  `};
`

export const Label = styled.label`
  padding: 2.2rem 0 2.2rem 1.8rem;
  display: grid;
  grid-template-columns: 2rem 1fr;
  align-items: center;
  gap: 1.2rem;
  cursor: pointer;
  a {
    color: ${(props) => props.theme.color.textHint};
    &:hover {
      color: ${(props) => darken(0.1, props.theme.color.textHint)};
    }
  }
`
